export default function LiveEvaluationLiveBanner() {
  return (
    <div className="border-t border-primary/20 bg-primary/5 px-4 py-3 sm:px-5" role="status">
      <p className="flex items-center justify-center gap-2 text-sm font-medium text-primary">
        <span className="h-2 w-2 animate-pulse rounded-full bg-primary" aria-hidden="true" />
        Live — happening right now
      </p>
    </div>
  );
}
